// @flow
export const FLAG_TYPE_KEYS = {
  PROFILE_NAME: 'name',
  PROFILE_PICTURE: 'picture',
  PROFILE_DESCRIPTION: 'description',
  COVER_IMAGE: 'cover-image',
  COVER_VIDEO: 'cover-video',
};

export default FLAG_TYPE_KEYS;
